"use client";

import * as React from "react";
import {
  Text,
  SectionCard,
  CardTitle,
  CardDescription,
  Section,
  Spinner,
} from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsSpinner() {
  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Spinner
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            An animated loading indicator for async operations.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/spinner" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Sizes</CardTitle>
              <CardDescription>Different spinner sizes</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <div className="flex items-center gap-8">
            <div className="text-center space-y-2">
              <Spinner size="sm" />
              <Text className="text-xs text-muted-foreground">Small</Text>
            </div>
            <div className="text-center space-y-2">
              <Spinner size="md" />
              <Text className="text-xs text-muted-foreground">Medium</Text>
            </div>
            <div className="text-center space-y-2">
              <Spinner size="lg" />
              <Text className="text-xs text-muted-foreground">Large</Text>
            </div>
            <div className="text-center space-y-2">
              <Spinner size="xl" />
              <Text className="text-xs text-muted-foreground">X-Large</Text>
            </div>
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">size</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">"sm" | "md" | "lg" | "xl"</td>
                <td className="py-2 font-mono text-xs">"md"</td>
                <td className="py-2 text-muted-foreground">Spinner size</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">className</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">string</td>
                <td className="py-2 font-mono text-xs">-</td>
                <td className="py-2 text-muted-foreground">Additional CSS classes</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
